import { createTheme } from "@mui/material";
import { red } from "@mui/material/colors";

export default createTheme({
  palette: {
    primary: {
      main: "#124116",
    },
    secondary: {
      main: "#81c784",
    },
    // background: {
    //   default: "#6fbf73",
    // },
    success: {
      main: "#4caf50",
    },
    error: {
      main: red[500],
      light: red[200],
    },
  },
});
